<div class="password-expired-container">
  <div class="password-expired-card card">
    <div class="public-forms-header mb-3">
      <img alt="Logo" [src]="logoUrl()">
    </div>

    <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="flex flex-col gap-6 w-150">
        <div>
          <p-floatlabel>
            <p-password formControlName="currentPassword" [feedback]="false" [toggleMask]="true" fluid />
            <label i18n="password expired form|current password label">Current password</label>
          </p-floatlabel>
          @let currentPasswordControl = form.get('currentPassword');
          @if (currentPasswordControl?.invalid && currentPasswordControl?.dirty) {
            @if (currentPasswordControl?.hasError('required')) {
              <p-message i18n="password expired form|current password required error" severity="error" variant="simple" size="small">
                Current Password is required.
              </p-message>
            }
            @for (remoteMessage of getRemoteValidationMessages(currentPasswordControl); track remoteMessage) {
              <p-message severity="error" variant="simple" size="small">
                {{ remoteMessage }}
              </p-message>
            }
          }
        </div>
        <div>
          <p-floatlabel>
            <p-password formControlName="password" [feedback]="false" autocomplete="new-password" [toggleMask]="true" fluid />
            <label i18n="password expired form|password label">Password</label>
          </p-floatlabel>
          @let passwordControl = form.get('password');
          @if (passwordControl?.invalid && passwordControl?.dirty) {
            @if (passwordControl?.hasError('required')) {
              <p-message i18n="password expired form|password required error" severity="error" variant="simple" size="small">
                Password is required.
              </p-message>
            }
            @if (passwordControl?.hasError('pattern')) {
              <p-message i18n="password expired form|password pattern error" severity="error" variant="simple" size="small">
                Password requires at least 1 lowercase letter, 1 uppercase letter, 1 digit and 1 special character.
              </p-message>
            }
            @for (remoteMessage of getRemoteValidationMessages(passwordControl); track remoteMessage) {
              <p-message severity="error" variant="simple" size="small">
                {{ remoteMessage }}
              </p-message>
            }
          }
        </div>
        <div>
          <p-floatlabel>
            <p-password formControlName="passwordConfirmation" [feedback]="false" [toggleMask]="true" fluid />
            <label i18n="password expired form|password confirmation label">Password Confirmation</label>
          </p-floatlabel>
          @let passwordConfirmationControl = form.get('passwordConfirmation');
          @if (passwordConfirmationControl?.invalid && passwordConfirmationControl?.dirty) {
            @if (passwordConfirmationControl?.hasError('required')) {
              <p-message i18n="password expired form|password confirmation required error" severity="error" variant="simple" size="small">
                Password Confirmation is required.
              </p-message>
            }
            @if (passwordConfirmationControl?.hasError('notEqual')) {
              <p-message i18n="password expired form|password confirmation equals error" severity="error" variant="simple" size="small">
                Password Confirmation must match Password.
              </p-message>
            }
            @for (remoteMessage of getRemoteValidationMessages(passwordConfirmationControl); track remoteMessage) {
              <p-message severity="error" variant="simple" size="small">
                {{ remoteMessage }}
              </p-message>
            }
          }
        </div>
        <div>
          <button pButton type="submit" i18n="password expired form|Change password button">
            Change password
          </button>
        </div>
      </div>
    </form>
  </div>

  <app-footer-links></app-footer-links>
</div>